<ion-toggle (click)="$event.stopPropagation()" (ionChange)="onToggle($event)" [checked]="isChecked"
            [disabled]="isDisabled" [name]="fieldName" [value]="enabledValue" color="secondary"
            [attr.aria-label]="ariaLabel || null"></ion-toggle>
